<div class="style-config-container">
  <h4>{{ i18n.t('vnm.styleRefMode') }}</h4>
  
  <div class="style-options">
    <label class="radio-option">
      <input
        type="radio"
        name="styleType"
        value="image"
        [checked]="config.type === 'image'"
        (change)="onStyleTypeChange('image')"
      />
      {{ i18n.t('vnm.refImage') }}
    </label>
    <label class="radio-option">
      <input
        type="radio"
        name="styleType"
        value="custom"
        [checked]="config.type === 'custom'"
        (change)="onStyleTypeChange('custom')"
      />
      {{ i18n.t('vnm.customModel') }}
    </label>
  </div>

  <!-- 参照画像設定 -->
  <div *ngIf="config.type === 'image'" class="style-image-section">
    <!-- ドロップゾーン -->
    <div
      *ngIf="!config.imageFile && !isUploading"
      class="style-reference-dropzone"
      [class.dragging]="isDragging"
      (dragover)="onStyleDragOver($event)"
      (dragleave)="onStyleDragLeave($event)"
      (drop)="onStyleDrop($event)"
    >
      <div class="upload-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 16L8.293 11.707C8.683 11.317 9.317 11.317 9.707 11.707L13.293 15.293C13.683 15.683 14.317 15.683 14.707 15.293L16 14M14 14L15.293 12.707C15.683 12.317 16.317 12.317 16.707 12.707L20 16M18 9C18 9.53043 17.7893 10.0391 17.4142 10.4142C17.0391 10.7893 16.5304 11 16 11C15.4696 11 14.9609 10.7893 14.5858 10.4142C14.2107 10.0391 14 9.53043 14 9C14 8.46957 14.2107 7.96086 14.5858 7.58579C14.9609 7.21071 15.4696 7 16 7C16.5304 7 17.0391 7.21071 17.4142 7.58579C17.7893 7.96086 18 8.46957 18 9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H21C22.1046 21 23 20.1046 23 19V5C23 3.89543 22.1046 3 21 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      
      <p class="upload-text">{{ i18n.t('vnm.dropStyleImage') }}</p>
      <p class="upload-hint">{{ i18n.t('vnm.styleImageHint') }}</p>
      
      <input
        type="file"
        id="styleFileInput"
        hidden
        (change)="onStyleFileSelected($event)"
        accept="image/*"
      />
      <div class="upload-buttons">
        <button
          type="button"
          class="spectrum-button spectrum-button--primary"
          (click)="triggerStyleFileInput()"
          [disabled]="isUploading"
        >
          {{ i18n.t('vnm.selectFile') }}
        </button>
      </div>
    </div>

    <!-- アップロード中の表示 -->
    <div *ngIf="isUploading" class="uploading-state">
      <div class="loading-spinner">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
          </circle>
        </svg>
      </div>
      <p class="uploading-text">{{ i18n.t('vnm.uploadingImage') }}</p>
    </div>

    <!-- 画像プレビュー -->
    <div *ngIf="config.imageFile" class="reference-image-preview">
      <div class="preview-header">
        <button
          type="button"
          class="remove-button"
          (click)="removeStyleImage()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="preview-content">
        <div class="preview-image">
          <img [src]="config.imageFile.preview" [alt]="i18n.t('vnm.styleRefImageAlt')" />
        </div>

        <div class="preview-info">
          <div class="file-info">
            <div class="file-name">{{ config.imageFile.name }}</div>
            <div class="file-size">{{ formatFileSize(config.imageFile.size) }}</div>
          </div>

          <div class="slider-control">
            <label for="styleStrength">
              {{ i18n.t('vnm.styleStrengthLabel') }}<span class="slider-value">{{ config.strength }}</span>
            </label>
            <input
              type="range"
              id="styleStrength"
              [min]="constants.MIN_STRENGTH"
              [max]="constants.MAX_STRENGTH"
              step="1"
              [value]="config.strength"
              (input)="onStrengthChange(+$any($event.target).value)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- カスタムモデル設定 -->
  <div *ngIf="config.type === 'custom'" class="custom-model-section">
    <!-- ローディングスピナー -->
    <div *ngIf="isLoadingCustomModels" class="loading-spinner-small">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
          <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
          <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
        </circle>
      </svg>
      <span>{{ i18n.t('vnm.loadingCustomModels') }}</span>
    </div>

    <!-- カスタムモデル選択ドロップダウン -->
    <select 
      *ngIf="!isLoadingCustomModels"
      id="customModel"
      name="customModel"
      [ngModel]="config.customModelId || null"
      (ngModelChange)="onCustomModelChange($event)"
    >
      <option [ngValue]="null" disabled>{{ i18n.t('vnm.selectCustomModel') }}</option>
      <option *ngFor="let model of customModels" [ngValue]="model.assetId">
        {{ customModelService.getModelDisplayInfo(model) }}
      </option>
    </select>
    

    <!-- モデル未取得の場合 -->
    <div *ngIf="!isLoadingCustomModels && customModels.length === 0" class="no-models-message">
      <p>{{ i18n.t('vnm.noCustomModels') }}</p>
    </div>

    <!-- 選択されたモデル情報 -->
    <div *ngIf="config.customModelId && customModelService.getModelById(config.customModelId)" class="custom-model-info">
      <p><strong>{{ i18n.t('vnm.selectedModelInfo') }}</strong></p>
      <p *ngIf="customModelService.getModelById(config.customModelId)?.conceptId">
        {{ i18n.t('vnm.keyword') }}<code>{{ customModelService.getModelById(config.customModelId)?.conceptId }}</code>
      </p>
      <p *ngIf="config.modelVersion">
        {{ i18n.t('vnm.modelVersion') }}<code>{{ config.modelVersion }}</code>
      </p>
      <p *ngIf="customModelService.getModelById(config.customModelId)?.samplePrompt">
        {{ i18n.t('vnm.samplePrompt') }}"{{ customModelService.getModelById(config.customModelId)?.samplePrompt }}"
      </p>
    </div>
  </div>

  <!-- 視覚的な適用量（共通） -->
  <div class="slider-control visual-intensity">
    <label for="visualIntensity">
      {{ i18n.t('vnm.visualIntensityLabel') }}<span class="slider-value">{{ config.visualIntensity }}</span>
    </label>
    <input
      type="range"
      id="visualIntensity"
      min="2"
      max="10"
      step="1"
      [value]="config.visualIntensity"
      (input)="onVisualIntensityChange(+$any($event.target).value)"
    />
  </div>

  <!-- 動画設定 -->
  <div class="video-settings-section">
    <h4>{{ i18n.t('vnm.videoSettings') }} <span class="optional">{{ i18n.t('kvs.optional') }}</span></h4>
    
    <!-- サイズとカメラモーション設定を横並び -->
    <div class="video-settings-horizontal">
      <div class="video-size-section">
        <label class="setting-label">{{ i18n.t('vnm.videoSizeAll') }}</label>
        <select class="spectrum-select" 
                [(ngModel)]="selectedVideoSize" 
                (ngModelChange)="onVideoSizeChange($event)"
                name="videoSize">
          <option *ngFor="let size of videoSizeOptions" [value]="size.value">
            {{ size.label }}
          </option>
        </select>
      </div>

      <div class="video-default-settings">
        <label class="setting-label">{{ i18n.t('vnm.defaultCameraMotion') }}</label>
        <app-video-settings-camera-only
          [(ngModel)]="videoSettingsCameraOnly"
          (settingsChange)="onVideoSettingsCameraOnlyChange($event)"
          [disabled]="false"
          name="videoSettingsCameraOnly">
        </app-video-settings-camera-only>
      </div>
    </div>
  </div>
</div>

<!-- Google Drive画像選択モーダル -->
<app-google-drive-image-selector
  [isOpen]="googleDriveSelectorOpen"
  [title]="i18n.t('vnm.selectStyleRef')"
  (imageSelected)="onGoogleDriveImageSelected($event)"
  (closed)="onGoogleDriveSelectorClosed()">
</app-google-drive-image-selector>